// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"f49147d2","771":"89a828b0"}[chunkId] + ".chunk.js";
};